import { Link } from "react-router-dom";
const ProjectCard = ({ project }) => {
	const tags = project.tags.map((tag, i) => {
		return (
			<div key={i} className="badge badge-outline badge-accent ">
				{tag}
			</div>
		);
	});
	return (
		<>
			<div className="card w-96 bg-dark glass text-neutral  my-5">
				{/* <figure>
					<Link to={`/projects/${project.slug}`}>
						<img src={project.images[0].path} alt={project.images[0].caption} />{" "}
					</Link>
				</figure> */}
				<div className="card-body p-5">
					<Link to={`/projects/${project.slug}`}>
						<h2 className="card-title font-mono">{project.title}</h2>
					</Link>
					{/* <p className="truncate">{project.description}</p> */}
					<div className="card-content">
						<p>{project.date}</p>
						<div className="mt-2">
							<p>Tags:</p>
							{tags}
						</div>
					</div>
					<div className="card-actions">
						{project.website ? (
							<a
								href={project.website}
								target="_blank"
								rel="noreferrer"
								className="btn btn-sm text-info"
							>
								Website
							</a>
						) : (
							""
						)}
						{project.github ? (
							<a
								href={project.github}
								target="_blank"
								rel="noreferrer"
								className="btn btn-sm text-info"
							>
								Github
							</a>
						) : (
							""
						)}
						{/* <Link className="btn btn-sm" to={`/projects/${project.slug}`}> Show Project</Link> */}
					</div>
				</div>
			</div>
		</>
	);
};
export default ProjectCard;
